import { ROUTE_PATH } from '@/constants/routePath';

export const headerItems = {
  [ROUTE_PATH.dashboard]: '대시보드',
  [ROUTE_PATH.mileageList]: '마일리지 조회',
  [ROUTE_PATH.newMileage]: '마일리지 등록',
  [ROUTE_PATH.scholarship]: '장학금 신청',
  [ROUTE_PATH.myPage]: '마이페이지',
};
